import { render, staticRenderFns } from "./infoadd.vue?vue&type=template&id=0f8b8d92&scoped=true"
import script from "./infoadd.vue?vue&type=script&lang=js"
export * from "./infoadd.vue?vue&type=script&lang=js"
import style0 from "./infoadd.vue?vue&type=style&index=0&id=0f8b8d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8b8d92",
  null
  
)

export default component.exports